/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { CitationType } from '@ecsper/speciality-contract';

export const expertWitnessCitationTypes: readonly CitationType[] = [
  {
    id: 'case',
    displayName: { 'en-GB': 'Case Law' },
  },
  {
    id: 'statute',
    displayName: { 'en-GB': 'Statute' },
  },
  {
    id: 'exhibit',
    displayName: { 'en-GB': 'Exhibit' },
  },
] as const;
